import React from 'react'

const PasskeyIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="94"
    height="94"
    fill="none"
    viewBox="0 0 94 94"
  >
    <path
      fill="#004B4E"
      d="M44.461 47.26a7.078 7.078 0 1 0 0-14.157 7.078 7.078 0 0 0 0 14.157M63.337 47.26a5.506 5.506 0 1 0-7.865 4.954v8.416l2.36 2.36 3.932-3.933-2.36-2.36 2.36-2.36-1.95-1.95a5.51 5.51 0 0 0 3.523-5.127m-5.506 0a1.573 1.573 0 1 1 0-3.147 1.573 1.573 0 0 1 0 3.147M50.659 50.437a9.4 9.4 0 0 0-3.838-.818H42.1a9.44 9.44 0 0 0-9.437 9.438v3.146h20.448v-8.667a8.1 8.1 0 0 1-2.453-3.099"
    ></path>
    <circle cx="47" cy="47" r="45" stroke="#004B4E" strokeWidth="3"></circle>
  </svg>
)

export default PasskeyIcon
